var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, PCSS, CustomElement, Watch, Components, UI, Utils, PropertyConverters, Defaults, CustomElementUtils, PropertyChangeEventName } from '@pacem/pacem-core';
import { AdapterPageButtonRefreshEventName } from './adapter';
//namespace Pacem.Components.UI {
const HANDLE_CSS = 'window-title';
let PacemWindowAreaElement = class PacemWindowAreaElement extends Components.PacemIterativeElement {
    constructor() {
        super(...arguments);
        this._zIndex = 1;
        this._startHandler = (evt) => {
            this._incrementZIndex(evt.detail.element);
            Utils.addClass(evt.detail.element, 'window-rescaling');
        };
        this._blurHandler = (evt) => {
            Utils.removeClass(evt.detail.element, 'window-rescaling');
        };
        this._focusHandler = (evt) => {
            this._incrementZIndex(evt.currentTarget);
        };
        this._itemPropertyChangeHandler = (evt) => {
            if (evt.detail.propertyName === 'floating' && evt.detail.currentValue === false) {
                const item = evt.currentTarget, ndx = this.items.indexOf(item);
                Utils.addClass(item, 'docking-in');
                this.adapter.select(ndx);
                Utils.addAnimationEndCallback(item, (e) => {
                    Utils.removeClass(e, 'docking-in');
                }, 150);
            }
        };
        this._adapterPagerCallback = (evt) => {
            const index = evt.detail.index, item = this.items[index];
            evt.detail.hide = item.hide || item.floating;
        };
    }
    validate(item) {
        return item instanceof PacemWindowElement;
    }
    _incrementZIndex(target) {
        if (this._zIndex != parseInt(target.style.zIndex)) {
            target.style.zIndex = '' + (++this._zIndex);
        }
    }
    connectedCallback() {
        super.connectedCallback();
        let shell = CustomElementUtils.findAncestorShell(this);
        this._behaviors = [
            shell.appendChild(this._dragDrop = document.createElement(P + '-drag-drop')),
            shell.appendChild(this._rescale = document.createElement(P + '-rescale'))
        ];
        this._dragDrop.handleSelector = '.' + HANDLE_CSS;
        //this._dragDrop.addEventListener(DragDropEventType.Init, this._focusHandler, false);
        this._rescale.addEventListener(UI.RescaleEventType.Start, this._startHandler, false);
        this._rescale.addEventListener(UI.RescaleEventType.End, this._blurHandler, false);
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        // adapter (reuse)
        if (Utils.isNull(this.adapter)) {
            const adapter = this.adapter = this.appendChild(document.createElement(P + '-adapter'));
            Utils.addClass(adapter, 'windows-adapter');
            adapter.labelCallback = (item, _) => {
                return item.caption;
            };
            adapter.swipeEnabled = false;
            adapter.deselectable = true;
            adapter.initialize(this);
        }
        this.adapter.addEventListener(AdapterPageButtonRefreshEventName, this._adapterPagerCallback, false);
    }
    disconnectedCallback() {
        if (!Utils.isNull(this.adapter)) {
            this.adapter.removeEventListener(AdapterPageButtonRefreshEventName, this._adapterPagerCallback, false);
            this.adapter.remove();
            this.adapter = null;
        }
        //this._dragDrop.removeEventListener(DragDropEventType.Init, this._focusHandler, false);
        this._rescale.removeEventListener(UI.RescaleEventType.End, this._blurHandler, false);
        this._rescale.removeEventListener(UI.RescaleEventType.Start, this._startHandler, false);
        for (let b of this._behaviors) {
            b.remove();
        }
        super.disconnectedCallback();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (name === 'index') {
            this._syncVisibility();
        }
    }
    register(item) {
        const retval = super.register(item);
        if (retval) {
            item.addEventListener(PropertyChangeEventName, this._itemPropertyChangeHandler, false);
            item.addEventListener('mousedown', this._focusHandler, false);
            for (let b of this._behaviors) {
                const ndx = item.behaviors.indexOf(b);
                if (ndx === -1) {
                    item.behaviors.push(b);
                }
            }
        }
        return retval;
    }
    unregister(item) {
        const retval = super.unregister(item);
        if (retval) {
            item.removeEventListener(PropertyChangeEventName, this._itemPropertyChangeHandler, false);
            item.removeEventListener('mousedown', this._focusHandler, false);
            for (let b of this._behaviors) {
                const ndx = item.behaviors.indexOf(b);
                if (ndx >= 0) {
                    item.behaviors.splice(ndx, 1);
                }
            }
        }
        return retval;
    }
    _syncVisibility() {
        let ndx = 0;
        const items = this.items ?? [];
        for (let item of items) {
            if (ndx === this.index) {
                Utils.addClass(item, 'dock-open');
            }
            else {
                Utils.removeClass(item, 'dock-open');
            }
            ndx++;
        }
    }
};
PacemWindowAreaElement = __decorate([
    CustomElement({
        tagName: P + '-window-area'
    })
], PacemWindowAreaElement);
export { PacemWindowAreaElement };
let PacemWindowElement = class PacemWindowElement extends Components.PacemIterableElement {
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (name === 'minimized' || name === 'floating') {
            this._syncLayout();
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._syncLayout();
    }
    _syncLayout() {
        (this.minimized ? Utils.addClass : Utils.removeClass).apply(this, [this, 'window-min']);
        (this.floating ? Utils.removeClass : Utils.addClass).apply(this, [this, 'window-dock']);
    }
};
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemWindowElement.prototype, "caption", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemWindowElement.prototype, "minimized", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemWindowElement.prototype, "floating", void 0);
PacemWindowElement = __decorate([
    CustomElement({
        tagName: P + '-window', shadow: Defaults.USE_SHADOW_ROOT,
        template: `<div class="${HANDLE_CSS}">
    <${P}-text text="{{ :host.caption || 'Window' }}"></${P}-text>
</div>
<div class="window-buttons ${PCSS}-buttonset"><div class="buttonset-right">
    <${P}-button class="button" on-click=":host.minimized = !:host.minimized" icon-glyph="{{ :host.minimized ? 'maximize' : 'minimize' }}" hide="{{ !:host.floating }}"></${P}-button>
    <${P}-button class="button" on-click=":host.floating = !:host.floating" css-class="{{ {'buttonset-first': !:host.floating} }}" icon-glyph="{{ :host.floating? 'lock_open' : 'lock' }}"></${P}-button>
</div></div>
<div class="window-content"><${P}-content></${P}-content></div>`
    })
], PacemWindowElement);
export { PacemWindowElement };
